import http from '@/services/http'
import Endpoints from '@/services/http/endpoints'
import { ApiEndpoints } from '@/types/backend'
import type { TODO } from '@/types'

export default {
  getProvinces() {
    return http.get(Endpoints.get(ApiEndpoints.provinces))
  },
  getBubbles(data: TODO) {
    return http.get(Endpoints.get(ApiEndpoints.bubbles, { provinceId: data }))
  },
  getFamilies(data: TODO, filter: TODO, source: TODO) {
    return http.get(
      Endpoints.get(ApiEndpoints.familiesList, {
        bubbleId: data,
        ...filter,
        offset: filter.offset - 1
      }),
      {
        ...source
      }
    )
  },
  getFamily(data: TODO) {
    return http.get(
      Endpoints.get(ApiEndpoints.details, {
        familyEditionId: data.familyEditionId,
        warehouseId: data.warehouseId,
        bubbleId: data.bubbleId,
        filterWarehouseId: data.filterWarehouseId,
        helpCriteriaId: data.helpCriteriaId,
        hasGreaterNeeds: data.hasGreaterNeeds
      })
    )
  },
  postDonor(data: TODO) {
    return http.post(
      Endpoints.get(ApiEndpoints.giftgiver, {
        familyEditionId: data.familyEditionId,
        warehouseId: data.warehouseId
      }),
      data.data
    )
  },
  getDonor(data: TODO) {
    return http.get(Endpoints.get(ApiEndpoints.giftgiver, data))
  },
  getConsent(): TODO {
    return http.get(Endpoints.get(ApiEndpoints.consent))
  },
  getGiftgiverCategories(): TODO {
    return http.get(Endpoints.get(ApiEndpoints.giftgiver_categories))
  },
  getResourceFilter(data: TODO) {
    return http.get(Endpoints.get(ApiEndpoints.filter_resource, { bubbleId: data }))
  },
  getLangs() {
    return http.get(import.meta.env.VITE_CUSTOM_LANG_URL)
  },
  getFamiliesAmount() {
    return http.get(Endpoints.get(ApiEndpoints.families_amount))
  }
}
